module.exports = __webpack_public_path__ + "media/images/facebook-b86562cb091df1385eff174ef9309c79.svg";